import React, {useEffect, useState, useRef} from "react"
import UserManagementCard from "../../../card/userManagementCard";
import Pagination from "../../../components/pagination";
import {useStateValue} from "../../../states/StateProvider";
import {ClipLoader, HashLoader} from "react-spinners";
import {RiArrowDownSFill, RiArrowUpSFill} from "react-icons/ri";
import {UserManagementHeaders} from "../../../staticData/userManagementHeaders";
import {formatDate} from "../../../helper/formatDate";
import {useNavigate} from "react-router";
import {GrUserAdmin} from "react-icons/gr";
import {FaUser, FaUserSecret} from "react-icons/fa";
import {MdSupervisorAccount} from "react-icons/md";

const UserManagementTable = ({users, pageSize, loading, total, role, filterIDUM, filterUM, page, setPageStates, roleSearchFilter, setRoleSearchFilter}) => {

    let PageSize = pageSize;
    const navigate = useNavigate()
    const [{sortUserColum, sortUserMethod}, dispatch] = useStateValue();
    const searChableFields = [3, 7]
    const [dropdownOpen, setDropdownOpen] = useState(false)
    const dropdownRef = useRef()

    const roleOptions = [
        { value: '', label: 'Alle', icon: null },
        { value: 'innendienst', label: 'Innendienst', icon: <GrUserAdmin size={'14px'} color={'#565c8c'}/> },
        { value: 'fkb', label: 'FKB', icon: <MdSupervisorAccount size={'14px'} color={'#3A46A9'}/> },
        { value: 'vp', label: 'VP', icon: <MdSupervisorAccount size={'14px'} color={'#0a523f'}/> },
        { value: 'controlling', label: 'Controlling', icon: <FaUserSecret size={'14px'} color={'#565c8c'}/> },
        { value: 'management', label: 'Management', icon: <FaUser size={'14px'} color={'#565c8c'}/> },
        { value: 'struktur', label: 'Struktur', icon: <FaUser size={'14px'} color={'#0a523f'}/> }
    ]

    const selectedOption = roleOptions.find(option => option.value === roleSearchFilter) || roleOptions[0]

    useEffect(() => {
        if (role === 'External') {
            navigate('/')
        }
    }, []);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setDropdownOpen(false)
            }
        }
        document.addEventListener('mousedown', handleClickOutside)
        return () => document.removeEventListener('mousedown', handleClickOutside)
    }, []);

    function ascSort(id) {
        dispatch({type: "SET_SORTUSERCOLUMN", item: id})
        dispatch({type: "SET_SORTUSERMETHOD", item: 'asc'})
    }

    function descSort(id) {
        dispatch({type: "SET_SORTUSERCOLUMN", item: id})
        dispatch({type: "SET_SORTUSERMETHOD", item: 'desc'})
    }

    function enableFilter(id, val) {
        if (id === 1) {
            dispatch({type: "SET_SORTBESTANDFILTERUM", item: {...filterUM, a: val}})
            dispatch({type: "SET_SORTBESTANDFILTERIDUM", item: {...filterIDUM, a: 1}})
        }
        if (id === 2) {
            dispatch({type: "SET_SORTBESTANDFILTERUM", item: {...filterUM, b: val}})
            dispatch({type: "SET_SORTBESTANDFILTERIDUM", item: {...filterIDUM, b: 2}})
        }
        if (id === 3) {
            dispatch({type: "SET_SORTBESTANDFILTERUM", item: {...filterUM, c: val}})
            dispatch({type: "SET_SORTBESTANDFILTERIDUM", item: {...filterIDUM, c: 3}})
        }
    }

    return (
        <div className="flex flex-col ml-3">
            <div className="overflow-x-auto sm:-mx-6 lg:-mx-8">
                <div className="py-2 inline-block min-w-full sm:px-6 lg:px-8">
                    <div className="overflow-hidden">
                        <table className="min-w-full text-left">
                            <thead className="border-y border-silver border-x-0">
                            <tr>
                                {
                                    UserManagementHeaders.map(header => (
                                        <th key={header.id} scope="col"
                                            className="text-sm font-medium text-grey px-6 py-2"
                                        >
                                                    <span className='flex justify-left'>
                                                          <span
                                                              className={`tooltip mt-1.5 text-center xl:h-fit lg:h-14 ${sortUserColum === header.id && 'text-mainBlue'}`}
                                                          >
                                                            {header.title}
                                                          </span>
                                                        {header.id !== 7 && <span>
                                                            <p className={`cursor-pointer ${sortUserColum === header.id && sortUserMethod === 'asc' ? 'text-mainBlue' : ''}`}
                                                               onClick={() => ascSort(header.id)}
                                                            >
                                                                <RiArrowUpSFill size='22px'/>
                                                            </p>
                                                            <p className={`-mt-3.5 cursor-pointer ${sortUserColum === header.id && sortUserMethod === 'desc' ? 'text-mainBlue' : ''}`}
                                                               onClick={() => descSort(header.id)}
                                                            >
                                                                <RiArrowDownSFill size='22px'/>
                                                            </p>
                                                        </span>}
                                                    </span>
                                            <span
                                                className={`${!(searChableFields.includes(header.id)) && 'opacity-0'}`}>
                                                {header.id === 7 ? (
                                                    <div ref={dropdownRef} className="relative w-full">
                                                        <div
                                                            className="w-full h-2 px-2 py-3 search bg-transparent cursor-pointer flex items-center justify-between"
                                                            onClick={() => setDropdownOpen(!dropdownOpen)}
                                                        >
                                                            <div className="flex items-center">
                                                                {selectedOption.icon && <span className="mr-1">{selectedOption.icon}</span>}
                                                                <span className="text-xs">{selectedOption.label}</span>
                                                            </div>
                                                            <RiArrowDownSFill size="14px" className={`transform transition-transform ${dropdownOpen ? 'rotate-180' : ''}`} />
                                                        </div>
                                                        {dropdownOpen && (
                                                            <div className="absolute top-full left-0 bg-white border border-gray-300 rounded shadow-lg z-50 max-h-60 overflow-y-auto min-w-max whitespace-nowrap">
                                                                {roleOptions.map((option) => (
                                                                    <div
                                                                        key={option.value}
                                                                        className="px-3 py-2 hover:bg-gray-100 cursor-pointer flex items-center text-xs"
                                                                        onClick={() => {
                                                                            setRoleSearchFilter(option.value)
                                                                            setDropdownOpen(false)
                                                                        }}
                                                                    >
                                                                        {option.icon && <span className="mr-2">{option.icon}</span>}
                                                                        <span>{option.label}</span>
                                                                    </div>
                                                                ))}
                                                            </div>
                                                        )}
                                                    </div>
                                                ) : (
                                                    <input type='text' placeholder='Suche...'
                                                           className='w-full h-2 px-2 py-3 search'
                                                           value={header.id === 1 ? filterUM.a : header.id === 2 ? filterUM.b : filterUM.c}
                                                           onChange={(e) => enableFilter(header.id, e.target.value)}
                                                    />
                                                )}
                                            </span>
                                        </th>
                                    ))
                                }
                            </tr>
                            </thead>
                            {
                                loading ?
                                    <thead>
                                    <tr className='mt-24 mb-24 absolute flex justify-center m-auto'>
                                        <td style={{marginLeft: '45vw'}}><ClipLoader color={'#afafaf'}/></td>
                                    </tr>
                                    </thead>
                                    : (users?.length > 0 && !loading) &&
                                        users?.map((u, index) => (
                                            <UserManagementCard
                                                key={index}
                                                index={index}
                                                name={u.fullname}
                                                userID={u.ID}
                                                users={users}
                                                role={u.role}
                                                isAdmin={u.isUserAdmin}
                                                email={u.email}
                                                status={u.status}
                                                lastLogin={formatDate(u.dateLastLogin, true)}
                                                created={formatDate(u.dateCreate, true)}
                                                prtnrNo={u.partnernr}
                                                valid={u.isActive}
                                            />
                                        ))
                            }
                        </table>
                        {
                            (users?.length === 0 && !loading) &&
                            <div className='centerItemsRelative h-80'>
                                <h2 className='text-2xl text-text text-center font-bold'>
                                    Es wurden keine Daten zu Ihrer Suche gefunden.
                                    <br/>
                                    Bitte prüfen Sie ggf. die Filter-Einstellungen.
                                </h2>
                            </div>
                        }

                        {
                            !loading && !roleSearchFilter &&
                            <div className='flex items-center justify-between mt-3 mb-2'>
                                <div className='flex items-center gap-4'>
                                    <p className='text-sm text-grey'>
                                        {page === 1 ? page : (1 + (Number(pageSize) * page)) - Number(pageSize)} bis {(users.length < Number(pageSize)) ? users.length + Number(pageSize) < total ? users.length + (Number(pageSize) * page) - Number(pageSize) : total : (Number(pageSize) + (Number(pageSize) * page)) - Number(pageSize)} von {total} Einträge
                                    </p>
                                    <h2 className='text-sm text-grey'>
                                        Einträge anzeigen:
                                        <span>
                                            <select onChange={setPageStates} className='bg-transparent text-mainBlue ml-2'>
                                                <option value={'10'}>{10}</option>
                                                <option value={'25'}>{25}</option>
                                                <option value={'10000'}>Alle</option>
                                            </select>
                                        </span>
                                    </h2>
                                </div>
                                <div className='flex-1 flex justify-center'>
                                    <Pagination
                                        className="pagination-bar"
                                        currentPage={page}
                                        totalCount={total}
                                        pageSize={PageSize}
                                        onPageChange={pageNo => dispatch({type: "SET_PAGE", item: pageNo})}
                                    />
                                </div>
                            </div>
                        }
                        {
                            !loading && roleSearchFilter &&
                            <div className='flex items-center mt-3 mb-2'>
                                <p className='text-sm text-grey'>
                                    {total} Einträge gefiltert
                                </p>
                            </div>
                        }

                    </div>
                </div>
            </div>
        </div>
    )
}

export default UserManagementTable